import { cn } from 'lib/utils';
import { TONE_CLASSES } from 'components/admin/audit/pillTone';
import type { AlignmentTicket } from 'api/sectorAlignmentApi';
import TicketKeyLink from './TicketKeyLink';

const CHILD_GRID = 'grid grid-cols-[120px_minmax(220px,1fr)_130px_120px] items-center gap-3';

const TicketRow = ({ ticket }: { ticket: AlignmentTicket }) => (
  <div role="row" className={cn(CHILD_GRID, 'h-11 border-t pl-[50px] pr-5')}>
    <span role="cell">
      <TicketKeyLink issueKey={ticket.key} />
    </span>
    <span role="cell" className="truncate text-[13px]" title={ticket.summary ?? undefined}>{ticket.summary || '—'}</span>
    <span role="cell">
      {ticket.status && (
        <span className={cn('inline-block max-w-full truncate rounded-md px-2 py-0.5 text-xs font-medium', TONE_CLASSES[ticket.closed ? 'emerald' : 'zinc'])}>
          {ticket.status}
        </span>
      )}
    </span>
    <span role="cell" className="text-[12.5px] text-muted-foreground">{ticket.sector || '—'}</span>
  </div>
);

export default TicketRow;
